/* eslint-disable no-redeclare */
import { HealthcareSessionId, HealthcareUserId } from '@hc-frontend/core-types';
import { z } from 'zod';

export const HandleContextualTrafficUseCaseParameters = z.object({
  sessionId: HealthcareSessionId,
  userId: HealthcareUserId,
  landingUrl: z.string(),
});

export type HandleContextualTrafficUseCaseParameters = z.infer<
  typeof HandleContextualTrafficUseCaseParameters
>;
